import { CartzillaIcon, CartzillaIconName } from "../icons/cartzilla-icon";

interface TableHeaderSortableButtonProps {
    direction?: "asc" | "desc";
    onClick?: () => void;
    children: React.ReactNode;
}

export const TableHeaderSortableButton = ({ direction, onClick, children }: TableHeaderSortableButtonProps) => {
    return (
        <button
            type="button"
            className={`btn fs-sm fw-semibold text-dark-emphasis table-sort d-flex align-items-center gap-2 p-0 ${direction}`}
            data-sort
            onClick={onClick}
        >
            {children}
            <div className={"d-flex flex-column"} data-sort-icons>
                <CartzillaIcon icon={CartzillaIconName.ArrowUp} className={`fs-xs fw-bolder ${direction === "asc" ? "" : "opacity-50"}`} />
                <CartzillaIcon icon={CartzillaIconName.ArrowDown} className={`fs-xs fw-bolder ${direction === "desc" ? "" : "opacity-50"}`} />
            </div>
        </button>
    );
};
